import _ from 'lodash';
import React from 'react';
import { taskRecordStatuses } from '~/lookups';
import SingleSelectFilter from './SingleSelectFilter';

const defaultOptions = _.values(taskRecordStatuses);

export default function ProjectRecordStatusFilter({
  placeholder = 'Task Archived',
  name,
  value,
  onChange,
  options = defaultOptions,
}) {
  return (
    <SingleSelectFilter
      icon="filter"
      placeholder={placeholder}
      name={name}
      value={value}
      renderValue={(value) => value.name}
      options={options}
      onChange={onChange}
    />
  );
}
